module.exports = __webpack_public_path__ + "media/styles/images/png/select-white-8041667b74c1599b1a915ebbd9d4fb87.png";